<div class="dialog-wrapper d-flex flex-column align-items-center gap-3">
  <img [src]="'/assets/images/popup-icons/' + config.icon + '.svg'" [alt]="config.icon" srcset="" class="icon" loading="lazy" />
  @if (config.title) {
    <span class="font-20 text-center">{{ config.title }}</span>
  }
  @if (config.desc) {
    <span class="font-18 text-center">{{ config.desc }}</span>
  }
  <div class="action-btns d-flex gap-3">
    @if (config.confirmBtnTxt) {
      <button type="button" class="btn btn-primary w-100" (click)="confirm()">{{ config.confirmBtnTxt }}</button>
    }
    @if (config.denyBtnTxt) {
      <button type="button" class="btn btn-warning" (click)="decline()">{{ config.denyBtnTxt }}</button>
    }
  </div>
</div>
